import activeConsentTemplate from '@/assets/templates/active-consent-template.html?raw';
import passiveConsentTemplate from '@/assets/templates/passive-consent-template.html?raw';

export interface ConsentTemplate {
  subject: string;
  body: string;
}

export const DEFAULT_ACTIVE_CONSENT_TEMPLATE: ConsentTemplate = {
  subject: "Resiliency/Wellness Assessment Consent Request",
  body: activeConsentTemplate
};

export const DEFAULT_PASSIVE_CONSENT_TEMPLATE: ConsentTemplate = {
  subject: "Resiliency/Wellness Assessment Notification",
  body: passiveConsentTemplate
};

/**
 * Get the default template for a given consent type
 */
export const getDefaultTemplate = (consentType: string): ConsentTemplate | null => {
  switch (consentType) {
    case 'CONSENT_TYPE_ACTIVE_CONSENT':
      return DEFAULT_ACTIVE_CONSENT_TEMPLATE;
    case 'CONSENT_TYPE_PASSIVE_CONSENT':
      return DEFAULT_PASSIVE_CONSENT_TEMPLATE;
    default:
      return null;
  }
};
